import { useState, useCallback, Fragment, useEffect } from "react";
import { UNIDADE_TEMPO, DIAS, DIAS_MES } from "../../utils/helpers/Constants";
import { Button, Typography, Stack, MenuItem, Chip } from "@mui/material";
import DialogFilterSelected from "./DialogFilterSelected";
import DialogProfile from "./DialogProfile";
import DialogFilterSave from "./DialogFilterSave";
import { useFormikContext } from "formik";
import { useStyles } from "./styles";
import { MenuButton } from "../../components/MenuButton";
import { useQuery, useMutation } from "react-query";
import {
  saveListProspecsPF,
  deleteAudience,
  updateListProspecsPF,
  saveReprocessAudience,
  updateReprocessAudience,
  listProfilesCSV,
  listClientMap,
  listReprocessAudience,
} from "../../services/insights";
import { useToast } from "../../hooks/useToast";
import { useDialogConfirmation } from "../../hooks/useDialogConfirmation";
import { DialogReprocessInsight } from "./DialogReprocessInsight";
import AnalyticsView from "./AnalyticsView";
import Overview from "./Overview";
import MovimentacaoReprocesso from "./ReprocessMovement";
import TabPanel from "../../components/TabPanel";
import { format, isValid } from "date-fns";
import DialogAddPerson from "../People/DialogAddPerson";
import { useNavigate } from "react-router-dom";
import { useAudience } from "../../hooks/useAudience";
import { Cluster } from "../../types/insights";
import {
  FileDownload,
  FormatListBulleted,
  Group,
  Person,
  RemoveShoppingCart,
  SmartToy,
  SwapHoriz,
} from "@mui/icons-material";
import MapsView from "./MapsView";

const numberToReal = (numero) => {
  let nmr = numero.toFixed(2).split(".");
  nmr[0] = "R$ " + nmr[0].split(/(?=(?:...)*$)/).join(".");
  return nmr[0];
};

const setTermometro = (term) => {
  switch (term) {
    case 1:
      return "Quente";
    case 2:
      return "Morno";
    case 3:
      return "Congelando";
    case 4:
      return "Congelado";
    default:
      return "Congelado";
  }
};

function Audiencias({ setShowFormikFilter }) {
  const styles = useStyles();
  const navigate = useNavigate();
  const [activeView, setActiveView] = useState<number>(0);
  const [open, setOpen] = useState<boolean>(false);
  const [dialogAddPerson, setDialogAddPerson] = useState<boolean>(false);
  const [modalPerfis, setModalOpen] = useState<boolean>(false);
  const [replica, setReplica] = useState(false);
  const [nomeFiltro, setNomeFiltro] = useState("");
  const [cluster, setClusterFiltro] = useState<Cluster>();
  const [reprocessar, setReprocessar] = useState(false);

  const dialog = useDialogConfirmation();

  const formik = useFormikContext();

  const toast = useToast();

  const context = useAudience();

  const handleDialogAddPerson = useCallback(() => {
    setDialogAddPerson(true);
    setModalOpen(false);
  }, []);

  useQuery(
    ["automation", context.filtroSelecionado?.idListProspectei],
    () => listReprocessAudience(context.filtroSelecionado?.idListProspectei),
    {
      onSuccess: (response) => {
        const unitTimeAutomacao = UNIDADE_TEMPO.find(
          (tempo) => tempo.value === response.UNID_TEMPO_AUTOMACAO
        );
        const tmp = response.DIA_AUTOMACAO
          ? response.UNID_TEMPO_AUTOMACAO !== "months"
            ? DIAS
            : DIAS_MES
          : null;

        const diaDisparoAutomacao = tmp
          ? tmp.find(
              (dia) => dia.value === parseInt(response.DIA_AUTOMACAO, 10)
            )
          : null;
        const reprocesso = {
          id_reprocesso: response.ID_REPROCESSO,
          id_prospeccao_lista: response.ID_PROSPECCAO_LISTA,
          active: response.ATIVO,
          unitAutomacao: response.UNID_AUTOMACAO,
          unitTimeAutomacao,
          diaDisparoAutomacao,
        };
        context.setReprocessoAudiencia(reprocesso);
      },
      enabled:
        Boolean(context.filtroSelecionado?.idListProspectei) &&
        Boolean(context.filtroSelecionado?.automacao),
    }
  );

  const map = useQuery("map", () => listClientMap(context.filtroConsulta));

  useEffect(() => {
    if (context.filtroConsulta.changeToRefetch) {
      map.refetch();
    }
    console.log(context.filtroConsulta.changeToRefetch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.filtroConsulta.changeToRefetch]);

  const newSaveListProspecsPF = useMutation(
    async (param1: any) => {
      const response = await saveListProspecsPF(param1);
      return response;
    },
    {
      onSuccess: () => {
        toast.show("Sucesso ao copiar audiência!", { severity: "success" });
        setReplica(false);
        setReprocessar(false);
        dialog.show(
          "Inicie sua campanha",
          "Deseja iniciar uma campanha com essa audiência ?",
          {
            onConfirmate: () => {
              navigate("/create-campaign");
              dialog.close();
            },
          }
        );
      },
      onError: () => {
        toast.show("Erro ao copiar audiência!", {
          severity: "error",
        });
      },
    }
  );

  const execDeleteAudience = useMutation(
    async (param1: any) => {
      const response = await deleteAudience(param1);
      return response;
    },
    {
      onSuccess: () => {
        toast.show("Sucesso ao excluir audiência!", { severity: "success" });
      },
      onError: () => {
        toast.show("Erro ao excluir audiência!", {
          severity: "error",
        });
      },
    }
  );

  const newUpdateListProspecsPF = useMutation(
    async (param1: any) => {
      const response = await updateListProspecsPF(param1);
      return response;
    },
    {
      onSuccess: () => {
        toast.show("Sucesso ao atualizar audiência!", { severity: "success" });
      },
      onError: () => {
        toast.show("Erro ao atualizar audiência!", {
          severity: "error",
        });
      },
    }
  );

  const newSaveReprocessAudience = useMutation(
    async (param1: any) => {
      const response = await saveReprocessAudience(param1);
      return response;
    },
    {
      onSuccess: () => {
        toast.show("Sucesso ao salvar automação!", { severity: "success" });
      },
      onError: () => {
        toast.show("Erro ao salvar automação!", {
          severity: "error",
        });
      },
    }
  );

  const newUpdateReprocessAudience = useMutation(
    async (param1: any) => {
      const response = await updateReprocessAudience(param1);
      return response;
    },
    {
      onSuccess: () => {
        toast.show("Sucesso ao atualizar automação!", { severity: "success" });
      },
      onError: () => {
        toast.show("Erro ao atualizar automação!", {
          severity: "error",
        });
      },
    }
  );

  const newListProfilesCSV = useMutation(
    async (param1: any) => {
      toast.show("Preparando audiência...", { severity: "info" });
      const response = await listProfilesCSV(param1);
      return response;
    },
    {
      onSuccess: () => {
        toast.show("Em minutos seu arquivo estará disponível!", {
          severity: "success",
        });
      },
      onError: () => {
        toast.show("Erro ao realizar download!", {
          severity: "error",
        });
      },
    }
  );

  const handleChangeView = useCallback((view: number) => {
    setActiveView(view);
  }, []);

  const updateAllFormikValues = (obj) => {
    for (var name in obj) {
      formik.setFieldValue(name, obj[name]);
    }
  };

  const salvarReprocessoAudiencia = async () => {
    const objAutomacao = {
      id_prospeccao: context.filtroSelecionado.idListProspectei,
      unid_tempo_automacao: context.reprocessoAudiencia.unitTimeAutomacao.value,
      unid_automacao: context.reprocessoAudiencia.unitAutomacao,
      hora_automacao: "00:00:00",
      dia_automacao:
        context.reprocessoAudiencia.diaDisparoAutomacao &&
        context.reprocessoAudiencia.diaDisparoAutomacao.value,
      active: Boolean(context.reprocessoAudiencia.active) ? 1 : 0,
      id_reprocesso: context.reprocessoAudiencia.id_reprocesso,
    };
    if (!Boolean(objAutomacao.id_reprocesso)) {
      await newSaveReprocessAudience.mutateAsync(objAutomacao);
    } else {
      await newUpdateReprocessAudience.mutateAsync(objAutomacao);
    }
    setReprocessar(false);
  };

  function selecionaLista(lista) {
    if (lista) {
      const filtro_completo = JSON.parse(lista.filtro_completo);
      const filtro = JSON.parse(lista.filtro);
      setNomeFiltro(
        `${lista.nameList} ${format(new Date(), "dd/MM/yyyy HH:mm")}`
      );

      context.setFiltroConsulta({
        ...filtro,
        idListProspectei: lista.idListProspectei,
        changeToRefetch: new Date().getTime(),
      });

      updateAllFormikValues(filtro_completo);
    } else {
      updateAllFormikValues([]);
    }

    context.setFiltroSelecionado(lista);
  }

  const salvarFiltro = async () => {
    const objParameters = JSON.parse(context.filtroSelecionado.filtro),
      filtroCompleto = JSON.parse(context.filtroSelecionado.filtro_completo);

    await newSaveListProspecsPF.mutateAsync({
      objParameters: {
        ...objParameters,
        nameList: nomeFiltro,
        idCluster: cluster.ID_CLUSTER_AUDIENCIA,
        namecluster: cluster.NOME,
      },
      filtroSegmentacao: filtroCompleto,
    });
  };

  function updateInsights() {
    const audiencia = context.filtroSelecionado;

    dialog.show(
      "Atualizar",
      `Deseja atualizar a audiência ${audiencia.nameList} ?`,
      {
        onConfirmate: async () => {
          const parameters = JSON.parse(audiencia.filtro),
            complete = JSON.parse(audiencia.filtro_completo);
          try {
            toast.show("Atualizando audiência...", { severity: "info" });
            await newUpdateListProspecsPF.mutateAsync({
              objParameters: {
                ...parameters,
                idListProspectei: audiencia.idListProspectei,
              },
              filtroSegmentacao: complete,
            });
          } catch (err) {
            console.log({ err });
          }
          dialog.close();
        },
      }
    );
  }

  const handleExportInsight = useCallback(async () => {
    await newListProfilesCSV.mutateAsync(
      context.filtroSelecionado.idListProspectei
    );
  }, [newListProfilesCSV, context.filtroSelecionado.idListProspectei]);

  return (
    <>
      <div data-testid="content-insight-name" className={styles.root}>
        <Typography variant="h4" data-testid="insight-name">
          {context.filtroSelecionado?.nameList || "Audiências"}
        </Typography>
      </div>
      <Stack data-testid="insight-content" spacing={4}>
        <Stack
          className={styles.rootInsightParams}
          data-testid="insight-filter-params"
          spacing={1}
          direction="row"
        >
          {[context.filtroSegmentacao].map((filtro, index) => (
            <Fragment key={index.toString()}>
              {filtro.selectedEstados &&
                filtro.selectedEstados.length > 0 &&
                filtro.selectedEstados.map((estado) => (
                  <Chip
                    key={estado}
                    data-testid="insight-filter-param-uf"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={estado.sigla || estado.value}
                  />
                ))}
              {filtro.selectedMunicipios &&
                filtro.selectedMunicipios.length > 0 &&
                filtro.selectedMunicipios.map((cidade) => (
                  <Chip
                    key={cidade}
                    data-testid="insight-filter-param-city"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={cidade.label}
                  />
                ))}
              {filtro.selectedBairros &&
                filtro.selectedBairros.length > 0 &&
                filtro.selectedBairros.map((bairro) => (
                  <Chip
                    key={bairro}
                    data-testid="insight-filter-param-district"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={bairro.label}
                  />
                ))}
              {filtro.selectedDDD &&
                filtro.selectedDDD.length > 0 &&
                filtro.selectedDDD.map((ddd) => (
                  <Chip
                    key={ddd}
                    data-testid="insight-filter-param-ddd"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={ddd.DDD}
                  />
                ))}
              {filtro.selectedMesNascimento &&
                filtro.selectedMesNascimento.length > 0 &&
                filtro.selectedMesNascimento.map((mes) => (
                  <Chip
                    key={mes}
                    data-testid="insight-filter-param-month"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={mes.label}
                  />
                ))}
              {filtro.selectedProfissao &&
                filtro.selectedProfissao.length > 0 &&
                filtro.selectedProfissao.map((profissao) => (
                  <Chip
                    key={profissao}
                    data-testid="insight-filter-param-uf"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={profissao.label}
                  />
                ))}
              {filtro.faixaEtaria && filtro.faixaEtaria.length > 0 && (
                <Chip
                  data-testid="insight-filter-param-age-group"
                  color="primary"
                  variant="outlined"
                  size="small"
                  label={`${filtro.faixaEtaria[0]} a ${filtro.faixaEtaria[1]} anos `}
                />
              )}
              {isValid(filtro.dataCadastroInicio) &&
                isValid(filtro.dataCadastroFim) && (
                  <Chip
                    data-testid="insight-filter-param-date-register"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={`${format(
                      new Date(filtro.dataCadastroInicio),
                      "dd/MM/yyyy"
                    )} a ${format(
                      new Date(filtro.dataCadastroFim),
                      "dd/MM/yyyy"
                    )}  `}
                  />
                )}
              {filtro.genre && (
                <Chip
                  data-testid="insight-filter-param-genre"
                  color="primary"
                  variant="outlined"
                  size="small"
                  label={filtro.genre.split(",")[0]}
                />
              )}
              {filtro.status && (
                <Chip
                  data-testid="insight-filter-param-status"
                  color="primary"
                  variant="outlined"
                  size="small"
                  label={
                    filtro.status.label || filtro.status ? "Ativo" : "Inativo"
                  }
                />
              )}
              {filtro.termometro && (
                <Chip
                  data-testid="insight-filter-param-thermometer"
                  color="primary"
                  variant="outlined"
                  size="small"
                  label={
                    filtro.termometro.label || setTermometro(filtro.termometro)
                  }
                />
              )}
              {filtro.eCliente && (
                <Chip
                  data-testid="insight-filter-param-is-client"
                  color="primary"
                  variant="outlined"
                  size="small"
                  label={`Cliente: ${
                    filtro.eCliente.label || filtro.eCliente ? "Sim" : "Não"
                  }`}
                />
              )}

              {filtro.email && (
                <Chip
                  data-testid="insight-filter-param-is-email"
                  color="primary"
                  variant="outlined"
                  size="small"
                  label={`Email: ${
                    filtro.email.label || filtro.email ? "Sim" : "Não"
                  }`}
                />
              )}
              {filtro.telefone && (
                <Chip
                  data-testid="insight-filter-param-is-telephone"
                  color="primary"
                  variant="outlined"
                  size="small"
                  label={`Telefone: ${
                    filtro.telefone.label || filtro.telefone ? "Sim" : "Não"
                  }`}
                />
              )}
              {filtro.celular && (
                <Chip
                  data-testid="insight-filter-param-is-cellphone"
                  color="primary"
                  variant="outlined"
                  size="small"
                  label={`Celular: ${
                    filtro.celular.label || filtro.celular ? "Sim" : "Não"
                  }`}
                />
              )}
              {filtro.endereco && (
                <Chip
                  data-testid="insight-filter-param-address"
                  color="primary"
                  variant="outlined"
                  size="small"
                  label={`Endereço: ${
                    filtro.endereco.label || filtro.endereco ? "Sim" : "Não"
                  }`}
                />
              )}

              {filtro.selectedStores &&
                filtro.selectedStores.length > 0 &&
                filtro.selectedStores.map((store) => (
                  <Chip
                    data-testid="insight-filter-param-stores"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={store.label}
                  />
                ))}
              {filtro.qtdeCompras && filtro.qtdeCompras.length > 0 && (
                <Chip
                  data-testid="insight-filter-param-qty-purchases"
                  color="primary"
                  variant="outlined"
                  size="small"
                  label={`${filtro.qtdeCompras[0]} a ${filtro.qtdeCompras[1]} unidades `}
                />
              )}
              {filtro.valorCompras && filtro.valorCompras.length > 0 && (
                <Chip
                  data-testid="insight-filter-param-value-purchases"
                  color="primary"
                  variant="outlined"
                  size="small"
                  label={`${numberToReal(
                    filtro.valorCompras[0]
                  )} a ${numberToReal(filtro.valorCompras[1])} valor gasto `}
                />
              )}
              {filtro.ticketMedio && filtro.ticketMedio.length > 0 && (
                <Chip
                  data-testid="insight-filter-param-average-ticket"
                  color="primary"
                  variant="outlined"
                  size="small"
                  label={`${numberToReal(
                    filtro.ticketMedio[0]
                  )} a ${numberToReal(filtro.ticketMedio[1])} ticket médio `}
                />
              )}
              {filtro.categoria_1 &&
                filtro.categoria_1.length > 0 &&
                filtro.categoria_1.map((grupo) => (
                  <Chip
                    key={grupo}
                    data-testid="insight-filter-param-ctg-1"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={grupo.label}
                  />
                ))}
              {filtro.categoria_2 &&
                filtro.categoria_2.length > 0 &&
                filtro.categoria_2.map((familia) => (
                  <Chip
                    key={familia}
                    data-testid="insight-filter-param-ctg-2"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={familia.label}
                  />
                ))}
              {filtro.selectedProdutos &&
                filtro.selectedProdutos.length > 0 &&
                filtro.selectedProdutos.map((produto) => (
                  <Chip
                    key={produto}
                    data-testid="insight-filter-param-ctg-3"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={produto.label}
                  />
                ))}

              {filtro.categoria_6 &&
                filtro.categoria_6.length > 0 &&
                filtro.categoria_6.map((colecao) => (
                  <Chip
                    key={colecao}
                    data-testid="insight-filter-param-ctg-6"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={colecao.label}
                  />
                ))}
              {filtro.selectedTamanhos &&
                filtro.selectedTamanhos.length > 0 &&
                filtro.selectedTamanhos.map((tamanho) => (
                  <Chip
                    key={tamanho}
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={tamanho.label}
                  />
                ))}
              {filtro.categoria_4 &&
                filtro.categoria_4.length > 0 &&
                filtro.categoria_4.map((cor) => (
                  <Chip
                    key={cor}
                    data-testid="insight-filter-param-ctg-4"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={cor.label || cor.cor}
                  />
                ))}
              {filtro.categoria_5 &&
                filtro.categoria_5.length > 0 &&
                filtro.categoria_5.map((fornecedor) => (
                  <Chip
                    key={fornecedor}
                    data-testid="insight-filter-param-ctg-5"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={fornecedor.label}
                  />
                ))}
              {filtro.n_categoria_1 &&
                filtro.n_categoria_1.length > 0 &&
                filtro.n_categoria_1.map((c1, index) => (
                  <Chip
                    icon={<RemoveShoppingCart />}
                    key={index.toString()}
                    data-testid="insight-filter-param-ctg-1"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={c1.label}
                  />
                ))}
              {filtro.n_categoria_2 &&
                filtro.n_categoria_2.length > 0 &&
                filtro.n_categoria_2.map((c2, index) => (
                  <Chip
                    icon={<RemoveShoppingCart />}
                    key={index.toString()}
                    data-testid="insight-filter-param-ctg-2"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={c2.label}
                  />
                ))}
              {filtro.n_categoria_3 &&
                filtro.n_categoria_3.length > 0 &&
                filtro.n_categoria_3.map((c3, index) => (
                  <Chip
                    icon={<RemoveShoppingCart />}
                    key={index.toString()}
                    data-testid="insight-filter-param-ctg-3"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={c3.label}
                  />
                ))}
              {filtro.n_categoria_4 &&
                filtro.n_categoria_4.length > 0 &&
                filtro.n_categoria_4.map((c4, index) => (
                  <Chip
                    icon={<RemoveShoppingCart />}
                    key={index.toString()}
                    data-testid="insight-filter-param-ctg-4"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={c4.label}
                  />
                ))}
              {filtro.n_categoria_5 &&
                filtro.n_categoria_5.length > 0 &&
                filtro.n_categoria_5.map((c5, index) => (
                  <Chip
                    icon={<RemoveShoppingCart />}
                    key={index.toString()}
                    data-testid="insight-filter-param-ctg-5"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={c5.label}
                  />
                ))}
              {filtro.n_categoria_6 &&
                filtro.n_categoria_6.length > 0 &&
                filtro.n_categoria_6.map((c6, index) => (
                  <Chip
                    icon={<RemoveShoppingCart />}
                    key={index.toString()}
                    data-testid="insight-filter-param-ctg-6"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={c6.label}
                  />
                ))}
              {filtro.n_categoria_7 &&
                filtro.n_categoria_7.length > 0 &&
                filtro.n_categoria_7.map((c7, index) => (
                  <Chip
                    icon={<RemoveShoppingCart />}
                    key={index.toString()}
                    data-testid="insight-filter-param-ctg-7"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={c7.label}
                  />
                ))}
              {filtro.n_categoria_8 &&
                filtro.n_categoria_8.length > 0 &&
                filtro.n_categoria_8.map((c8, index) => (
                  <Chip
                    icon={<RemoveShoppingCart />}
                    key={index.toString()}
                    data-testid="insight-filter-param-ctg-8"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={c8.label}
                  />
                ))}
              {filtro.n_categoria_9 &&
                filtro.n_categoria_9.length > 0 &&
                filtro.n_categoria_9.map((c9, index) => (
                  <Chip
                    icon={<RemoveShoppingCart />}
                    key={index.toString()}
                    data-testid="insight-filter-param-ctg-9"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={c9.label}
                  />
                ))}
              {filtro.n_categoria_10 &&
                filtro.n_categoria_10.length > 0 &&
                filtro.n_categoria_10.map((c10, index) => (
                  <Chip
                    icon={<RemoveShoppingCart />}
                    key={index.toString()}
                    data-testid="insight-filter-param-ctg-10"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={c10.label}
                  />
                ))}
              {filtro.pesquisa_1 &&
                filtro.pesquisa_1.length > 0 &&
                filtro.pesquisa_1.map((p1, index) => (
                  <Chip
                    icon={<FormatListBulleted />}
                    key={index.toString()}
                    data-testid="insight-filter-param-sch-1"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={p1.RESPOSTA}
                  />
                ))}
              {filtro.pesquisa_2 &&
                filtro.pesquisa_2.length > 0 &&
                filtro.pesquisa_2.map((p2, index) => (
                  <Chip
                    icon={<FormatListBulleted />}
                    key={index.toString()}
                    data-testid="insight-filter-param-sch-2"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={p2.RESPOSTA}
                  />
                ))}
              {filtro.pesquisa_3 &&
                filtro.pesquisa_3.length > 0 &&
                filtro.pesquisa_3.map((p3, index) => (
                  <Chip
                    icon={<FormatListBulleted />}
                    key={index.toString()}
                    data-testid="insight-filter-param-sch-3"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={p3.RESPOSTA}
                  />
                ))}
              {filtro.pesquisa_4 &&
                filtro.pesquisa_4.length > 0 &&
                filtro.pesquisa_4.map((p4, index) => (
                  <Chip
                    icon={<FormatListBulleted />}
                    key={index.toString()}
                    data-testid="insight-filter-param-sch-4"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={p4.RESPOSTA}
                  />
                ))}
              {filtro.pesquisa_5 &&
                filtro.pesquisa_5.length > 0 &&
                filtro.pesquisa_5.map((p5, index) => (
                  <Chip
                    icon={<FormatListBulleted />}
                    key={index.toString()}
                    data-testid="insight-filter-param-sch-5"
                    color="primary"
                    variant="outlined"
                    size="small"
                    label={p5.RESPOSTA}
                  />
                ))}
            </Fragment>
          ))}
        </Stack>

        <Stack
          data-testid="insight-btn-actions"
          direction="row"
          justifyContent="space-between"
        >
          <Stack
            data-testid="insight-btn-views"
            direction="row"
            spacing={2}
            className={styles.rootActions}
          >
            <Button
              data-testid="insight-btn-overview"
              onClick={() => handleChangeView(0)}
              variant={activeView === 0 ? "contained" : "outlined"}
            >
              Visão geral
            </Button>
            <Button
              data-testid="insight-btn-analytic-view"
              onClick={() => handleChangeView(1)}
              variant={activeView === 1 ? "contained" : "outlined"}
            >
              Visão analítica
            </Button>
            <Button
              data-testid="insight-btn-analytic-view"
              onClick={() => handleChangeView(2)}
              variant={activeView === 2 ? "contained" : "outlined"}
            >
              Visão mapa
            </Button>
            {context.reprocessoAudiencia &&
              context.reprocessoAudiencia.id_reprocesso && (
                <Button
                  data-testid="insight-btn-movement-view"
                  startIcon={<SwapHoriz />}
                  onClick={() => handleChangeView(3)}
                  variant={activeView === 3 ? "contained" : "outlined"}
                >
                  Movimentação
                </Button>
              )}
          </Stack>
          <Stack
            data-testid="insight-btn-actions-insight"
            direction="row"
            spacing={2}
            className={styles.rootActions}
          >
            <Button
              data-testid="insight-btn-dialog-insight"
              startIcon={<Group />}
              onClick={() => setOpen(true)}
              variant="outlined"
            >
              Audiências
            </Button>
            <Button
              data-testid="insight-btn-dialog-clients"
              startIcon={<Person />}
              onClick={() => setModalOpen(true)}
              variant="outlined"
            >
              Clientes
            </Button>

            {context.filtroSelecionado.filtro_completo && (
              <MenuButton
                data-testid="insight-btn-replicate"
                id="btn-apps"
                variant="outlined"
                label="Replicar"
              >
                <MenuItem
                  data-testid="insight-btn-replicate-copy"
                  onClick={() => setReplica(true)}
                >
                  Copiar
                </MenuItem>
                <MenuItem
                  data-testid="insight-btn-replicate-update"
                  onClick={() => updateInsights()}
                >
                  Atualizar
                </MenuItem>
              </MenuButton>
            )}
            {context.filtroSelecionado.idListProspectei && (
              <Button
                data-testid="insight-btn-export"
                disabled={newListProfilesCSV.isLoading}
                startIcon={<FileDownload />}
                variant="outlined"
                onClick={handleExportInsight}
              >
                Exportar
              </Button>
            )}
            {context.filtroSelecionado.idListProspectei && (
              <Button
                data-testid="insight-btn-automate"
                startIcon={<SmartToy />}
                variant="contained"
                onClick={() => setReprocessar(true)}
              >
                Automatizar
              </Button>
            )}
            <Button
              data-testid="insight-btn-edit-or-create"
              onClick={() => setShowFormikFilter(true)}
              variant="contained"
            >
              {context.filtroSelecionado.nameList
                ? "Editar audiência"
                : "Criar audiência"}
            </Button>
          </Stack>
        </Stack>
        <TabPanel
          data-testid="insight-panel-overview"
          index={0}
          value={activeView}
        >
          <Overview />
        </TabPanel>
        <TabPanel
          data-testid="insight-panel-analytic"
          index={1}
          value={activeView}
        >
          <AnalyticsView />
        </TabPanel>
        <TabPanel data-testid="insight-panel-map" index={2} value={activeView}>
          <MapsView clients={map.data} loadingClient={map.isFetching} />
        </TabPanel>
        <TabPanel
          data-testid="insight-panel-movement"
          index={3}
          value={activeView}
        >
          <MovimentacaoReprocesso />
        </TabPanel>
      </Stack>

      {open && (
        <DialogFilterSelected
          //@ts-ignore
          open={open}
          onClose={() => setOpen(false)}
          filtro={context.filtroSelecionado}
          onSelect={(filtro) => {
            selecionaLista(filtro);
            setOpen(!open);
          }}
          onDelete={async (id) => {
            try {
              await execDeleteAudience.mutateAsync(id);

              context.setFiltroSelecionado([]);
              updateAllFormikValues(context.STATIC_FILTER);
            } catch (err) {
              console.log({ err });
            }
          }}
        />
      )}
      {modalPerfis && (
        <DialogProfile
          //@ts-ignore
          clients={map.data}
          loadingClient={map.isFetching}
          open={modalPerfis}
          onClose={() => setModalOpen(false)}
          onAddPerson={handleDialogAddPerson}
        />
      )}

      <DialogFilterSave
        loadingFilter={newSaveListProspecsPF.isLoading}
        open={replica}
        onClose={() => setReplica(false)}
        onChange={(state, value) =>
          state === "clusterName"
            ? setClusterFiltro(value)
            : setNomeFiltro(value)
        }
        onSave={() => salvarFiltro()}
      />

      <DialogAddPerson
        //@ts-ignore
        open={dialogAddPerson}
        onClose={() => setDialogAddPerson(false)}
      />

      <DialogReprocessInsight
        loading={
          newSaveReprocessAudience.isLoading ||
          newUpdateReprocessAudience.isLoading
        }
        open={reprocessar}
        value={context.reprocessoAudiencia}
        onClose={() => {
          setReprocessar(false);
        }}
        onSave={() => salvarReprocessoAudiencia()}
        onChange={(state) =>
          context.setReprocessoAudiencia({
            ...context.reprocessoAudiencia,
            ...state,
          })
        }
      />
    </>
  );
}

export default Audiencias;
